import { ElementRef, Injectable } from '@angular/core';
import { geojson } from '@lib/geojson';
import Map from 'ol/Map';
import { TooltipManager } from '@app/utilities/map/features/tooltip';
import { PolygonManager } from '@app/utilities/map/features/polygon';
import { createMapSatelliteLayer } from '@app/utilities/map/ol/satellite-layer';
import { View } from 'ol';
import { PRIMARY_COLOR } from 'src/colors';

@Injectable({
    providedIn: 'root',
})
export class ImportMuckpileMapService {
    public map: Map | null = null;
    public tooltipManager: TooltipManager | null = null;
    public polygonManager: PolygonManager | null = null;
    private mapElementRef: HTMLElement | null = null;

    public initializeMap(center: geojson.Coord, mapElement: ElementRef, muckpileCoord:any) {
        this.mapElementRef = mapElement.nativeElement;
        this.initializeBaseSatelliteLayer(mapElement.nativeElement, center, 17);
        this.tooltipManager = new TooltipManager(this.map);
        this.polygonManager = new PolygonManager(this.map, this.tooltipManager);

        this.reCenterMap([muckpileCoord][0][0], 16);
        this.polygonManager.clearAll();

        this.polygonManager?.add({
            coordinates: [muckpileCoord],
            content: "",
            color: PRIMARY_COLOR
        });
    }

    public initializeBaseSatelliteLayer(
        mapElement: HTMLElement,
        center: geojson.Coord,
        zoom: number
    ) {
        // Initialize the OpenLayers map with Google Maps as the base layer
        this.map = new Map({
            target: mapElement,
            layers: [createMapSatelliteLayer()],
            view: new View({
                center: center,
                zoom: zoom
            }),
            controls: []
        });
        return this.map;
    }

     public reCenterMap(center: geojson.Coord, zoom?: number) {
            if (this.map) {
                const view = this.map.getView();
                view.setCenter(center);
                if (zoom !== undefined) {
                    view.setZoom(zoom);
                }
            }
        }

    public cleanup() {
        if (this.map) {
            this.map.dispose();
            this.map = null;
        }
        this.tooltipManager = null;
        this.polygonManager = null;
        this.mapElementRef = null;
    }
}
